exports.install = function (Vue, options) {
	//获取可认领物种列表
	Vue.prototype.getclaim = function(value={})
	{
		value.limitPage=this.$store.state.production.page;
		value.limitCount=this.$store.state.production.pagesize;
		value.m_qaeda_id=this.getCookie(this.config.jdid);
		return this.axiosget("/api/pt/claim/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('claim1',response.data.data);
			}
		})
	};
	//获取所有可认领物种列表
	Vue.prototype.getclaimall = function(value={})
	{
		value.m_qaeda_id=this.getCookie(this.config.jdid);
		this.axiosget("/api/pt/claim/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('claim2',response.data.data);
			}
		})
	};
	//物种认领
	Vue.prototype.archiveStartC = function(value)
	{
		return this.axiospost("/api/pt/claim/archiveStart",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getspecies();
			}
			return response;
		});
	};
}